/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled, { css } from 'styled-components';

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: none;
  padding: 12px 16px;
  gap: 10px;
`;

export const MyProgressBar = styled.progress`
  width: 64px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 10px;
  opacity: 0.5;
  ::-webkit-progress-bar {
    background-color: ${Palette.PrimaryGray._200};
  }

  ::-webkit-progress-value {
    background-color: ${Palette.Primary._300};
  }
`;
export const VerticalSeparator = styled.div`
  height: 32px;
  width: 1px;
  background-color: ${Palette.PrimaryGray._200};
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  > span {
    color: ${Palette.PrimaryGray._700};
  }
`;
